export default {
  errors: null,
  product_sets: [],
  loading: false,
  count: 0,
  totalCount: 0,
  filterValues: [],
  fieldHandles: []
};
